import { useEffect, useMemo } from "react";
import { RAZMER_STAGE_ID } from "../components/OSStageTree";
import { RNWorkOrderDoc } from "./useRNWorkOrder";

interface Params {
  viewer?: RNWorkOrderDoc["viewer"];
  isAdmin: boolean;
  hasWrite: (moduleCode: string) => boolean;
  activeStage: string;
  setActiveStage: (id: string) => void;
}

// UX-only mirror of the server's RN scope: which subprocesses the user may see and
// whether stock-moving buttons are rendered. The server enforces both.
export const useRNViewerScope = ({ viewer, isAdmin, hasWrite, activeStage, setActiveStage }: Params) => {
  const allStages = isAdmin || !!viewer?.allStages;
  const subprocessIds = viewer?.subprocessIds;
  // undefined = all subprocesses; no viewer yet and not admin = fail-closed (empty set).
  const allowedSubprocessIds = useMemo<Set<string> | undefined>(
    () => (allStages ? undefined : new Set(subprocessIds ?? [])),
    [allStages, subprocessIds],
  );
  const canMoveStock = isAdmin || (viewer ? viewer.canMoveStock : hasWrite("MATERIAL_DOCUMENTS"));
  const hasNoAssignedStages = !allStages && !!viewer && viewer.subprocessIds.length === 0;

  useEffect(() => {
    if (!activeStage || activeStage === RAZMER_STAGE_ID) return;
    if (allowedSubprocessIds && !allowedSubprocessIds.has(activeStage)) setActiveStage(RAZMER_STAGE_ID);
  }, [activeStage, allowedSubprocessIds, setActiveStage]);

  return { allowedSubprocessIds, canMoveStock, hasNoAssignedStages };
};
